import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {IRootState} from "../../store/store";
import {VendorState} from "../types/VendorState";

const initialState: VendorState = {
    vendorId: null
};

export const vendorDetailSlice = createSlice({
    name: "vendorDetail",
    initialState,
    reducers: {
        openVendorReportModal: (state, action: PayloadAction<{vendorId: number}>) => {
            state.vendorId = action.payload.vendorId;
        },
        closeVendorReportModal: (state) => {
            state.vendorId = null;
        }
    }
});

export const {openVendorReportModal, closeVendorReportModal} = vendorDetailSlice.actions;
export const selectVendorReportModalId = (state: IRootState) => state.vendorDetail.vendorId;
